import { useDispatch, useSelector } from 'react-redux'
import { getReopenTabDialog } from '../Selectors'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { useCallback } from 'react'
import { setReopenTabDialog } from '../ActionCreators'
import useReopenTab from '../../VNReopenTab/hooks/useReopenTab'
import { getSelectedOrder } from '../../selectors/order'
import { setManagerApprovalPrompt } from '../../VNManagerApproval/ActionCreators'

export const VNReopenTabDialog = () => {
  const dispatch = useDispatch()
  const order = useSelector(getSelectedOrder)

  const { reopenTab, reopenOfflineTab } = useReopenTab()

  const reopenTabDialogProps = useSelector((state) => getReopenTabDialog(state))
  const open = reopenTabDialogProps.get('open')
  const isFullyClosedOfflineTab = reopenTabDialogProps.get('isFullyClosedOfflineTab')

  const closeHandler = useCallback(() => {
    dispatch(setReopenTabDialog({ open: false }))
  }, [dispatch])

  const reopenHandler = useCallback(() => {
    const onSuccess = () => {
      if (isFullyClosedOfflineTab) {
        reopenOfflineTab(order)
        return
      }

      reopenTab(order)
      return
    }

    dispatch(setReopenTabDialog({ open: false }))
    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Reopen Tab' }))
  }, [dispatch, order, reopenTab, isFullyClosedOfflineTab, reopenOfflineTab])

  if (!open) {
    return null
  }

  return (
    <ConfirmModalV2
      headerText={'Reopen Tab?'}
      subtext={
        'Enter manager PIN to reopen the tab. Once reopened, the gratuity and payments will need to be re-applied when closing.'
      }
      buttonTwoText={'YES, REOPEN'}
      onButtonTwoClick={reopenHandler}
      buttonOneText={'NO, NEVER MIND'}
      onButtonOneClick={closeHandler}
    />
  )
}
